import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DDeclaracionSugerida } from '@dian-api/renta210v18';

const fields = [
  {
    seccion: 'Patrimonio',
    data: [
      [
        { id: 29, text: 'Total patrimonio bruto', attr: 'valSugeridoCasilla29' },
        { id: 30, text: 'Deudas', attr: 'valSugeridoCasilla30' },
      ]
    ]
  },
  {
    seccion: 'Rentas de trabajo',
    data: [
      [
        { id: 355, text: 'Salarios', attr: 'valSugeridoCasilla355' },
        { id: 33, text: 'Ingresos no constitutivos de renta', attr: 'valSugeridoCasilla33' }        
      ],
      [
        { id: 35, text: 'Aportes voluntarios AFC, FVP y/o AVC', attr: 'valSugeridoCasilla35' },
        { id: 36, text: 'Otras rentas exentas', attr: 'valSugeridoCasilla36' }
      ],
     /* [        
        { id: 39, text: 'Otras deducciones imputables', attr: 'valSugeridoCasilla39' },
      ]*/
    ]
  },
  {
    seccion: 'Rentas por honorarios y compensación de servicios personles sujetos a costos y gastos y no a las rentas exentas numeral 10 art. 206 E.T.',
    data: [
      [
        { id: 43, text: 'Ingresos brutos', attr: 'valSugeridoCasilla43' },
        { id: 44, text: 'Ingresos no constitutivos de renta', attr: 'valSugeridoCasilla44' }
      ],
      [
        { id: 47, text: 'Aportes voluntarios AFC, FVP y/o AVC', attr: 'valSugeridoCasilla47' },
        { id: 51, text: 'Otras deducciones imputables', attr: 'valSugeridoCasilla51' }
        //{ id: 48, text: 'Otras rentas exentas', attr: 'valSugeridoCasilla48' }
      ]
      /*,
      [
        { id: 51, text: 'Otras deducciones imputables', attr: 'valSugeridoCasilla51' }
      ]*/
    ]
  },
  {
    seccion: 'Rentas de capital',
    data: [
      [
        { id: 58, text: 'Ingresos brutos ', attr: 'valSugeridoCasilla58' },
        { id: 59, text: 'Ingresos no constitutivos de renta', attr: 'valSugeridoCasilla59' }
      ],
      [
        { id: 63, text: 'Aportes voluntarios AFC, FVP y/o AVC', attr: 'valSugeridoCasilla63' },
        { id: 67, text: 'Otras deducciones imputables', attr: 'valSugeridoCasilla67' }
     //   { id: 64, text: 'Otras rentas exentas', attr: 'valSugeridoCasilla64' }
      ]
      /*[ 
        { id: 67, text: 'Otras deducciones imputables', attr: 'valSugeridoCasilla67' }
      ]*/
    ]
  },
  {
    seccion: 'Rentas no laborales',
    data: [
      [
        { id: 74, text: 'Ingresos brutos', attr: 'valSugeridoCasilla74' },
        { id: 76, text: 'Ingresos no constitutivos de renta ', attr: 'valSugeridoCasilla76' }
      ],
      [
        { id: 80, text: 'Aportes voluntarios AFC, FVP y/o AVC', attr: 'valSugeridoCasilla80' },
        { id: 98, text: 'Rentas presuntiva', attr: 'valSugeridoCasilla98' },
    
      ],
      [
         //   { id: 81, text: 'Otras rentas exentas', attr: 'valSugeridoCasilla81' }
        { id: 84, text: 'Otras deducciones imputables', attr: 'valSugeridoCasilla84' }
       
      ]
    ]
  },
  {
    seccion: 'Cédula de pensiones',
    data: [
      [       
        { id: 99, text: 'Ingresos brutos por rentas de pensiones del país y del exterior ', attr: 'valSugeridoCasilla99' },
        { id: 100, text: 'Ingresos no constitutivos de renta', attr: 'valSugeridoCasilla100' }
      ],
      [
        { id: 102, text: 'Rentas exentas de pensiones', attr: 'valSugeridoCasilla102' }
      ] 
    ]
  },
  {
    seccion: 'Cédula dividendos y participaciones',
    data: [
      [
        { id: 104, text: 'Dividendos y participaciones 2016 y anteriores, y otros', attr: 'valSugeridoCasilla104' },
        { id: 105, text: 'Ingresos no constitutivos de renta ', attr: 'valSugeridoCasilla105' }
      ],
      [
        { id: 107, text: '1a. Subcédula año 2017 y siguientes numeral 3 art. 49 E.T.', attr: 'valSugeridoCasilla107' },
    //    { id: 110, text: 'Rentas exentas casilla 109', attr: 'valSugeridoCasilla110' }
      ]
    ]
  },
  {
    seccion: 'Ganancias ocasionales',
    data: [
      [
        { id: 112, text: 'Ingresos por ganancias ocasionales en el país y del exterior', attr: 'valSugeridoCasilla112' },
        { id: 114, text: 'Ganancias ocasionales no gravadas y exentas', attr: 'valSugeridoCasilla114' }
      ]
    ]
  },
  {
    seccion: 'Liquidación privada',
    data: [
      [
        { id: 123, text: 'Donaciones', attr: 'valSugeridoCasilla123' },
        { id: 130, text: 'Anticipo renta liquidado año gravable anterior', attr: 'valSugeridoCasilla130' }
      ],
      [
        { id: 131, text: 'Saldo a favor del año gravable anterior sin solicitud de devolución y/o compensación ', attr: 'valSugeridoCasilla131' },
        { id: 132, text: 'Retenciones año gravable a declarar', attr: 'valSugeridoCasilla132' }
      ],
      [
       
       { id: 124, text: 'Donaciones', attr: 'valSugeridoCasilla124' },
        { id: 122, text: 'Impuestos pagados en el exterior', attr: 'valSugeridoCasilla122' }
      ],
   //   [
       // { id: 133, text: 'Anticipo renta para año gravable siguiente', attr: 'valSugeridoCasilla133' },
     //   { id: 125, text: 'Otros', attr: 'valSugeridoCasilla125' }
   //   ]
    ]
    
  },
  {
    seccion: 'Facturación Electrónica',
    data: [
      [
        { id: 297, text: 'Valor compras con factura electrónica', attr: 'valSugeridoCasilla297' },
      ]
      
    ]
    
  },
  {
    seccion: 'Deducciones imputables sin limitantes: cesantías acumuladas a 31 de diciembre de 2016',
    data: [
      [
        { id: 246, text: 'Valor de la parte exenta de las cesantías retiradas', attr: 'valSugeridoCasilla246' },
      ]
      
    ]
    
  }
];

interface DataDecla {
  readOnly: boolean;
  formData: DDeclaracionSugerida
}

@Component({
  selector: 'app-sugerida',
  templateUrl: './sugerida.component.html',
  styleUrls: ['./sugerida.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SugeridaComponent implements OnInit {

  dataFields: any[] = fields;
  disableButtons: boolean = false;
  annioGravable:string;

  constructor(
    private dialogRef: MatDialogRef<SugeridaComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DataDecla
  ) {}

  ngOnInit() {
    this.annioGravable=this.getValue('anioGravable');
  }

  getValue(attr: string) {
    return this.data.formData[attr];
  }

  sendData() {
    this.disableButtons = true;
    setTimeout(() => {
      this.dialogRef.close(true);
    }, 500);    
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/dialogos/sugerida/sugerida.component.ts